import { useTypewriterRename } from "../../hooks/useTypewriterRename"
import type { IProps } from "./interfaces"
import classes from "./styles.module.css"

/**
 * TypewriterText — renders `value`, and when `value` changes animates a
 * backspace→retype "rename" (e.g. `Speaker_1` → `Gerard`) with a blinking
 * caret. Pure, dumb, reduced-motion-safe. The reusable face of the app's
 * motion design language for label/value renames; see
 * `useTypewriterRename` + feedback_micro_animation_design_language.
 */
export const TypewriterText = ({
  value,
  className,
  caretClassName,
  showCaretWhenIdle = false,
  stepMs,
}: IProps): React.JSX.Element => {
  const { text, animating } = useTypewriterRename(value, { stepMs })
  const showCaret = animating || showCaretWhenIdle

  return (
    <span className={className} data-animating={animating ? "true" : "false"}>
      {text}
      {showCaret && <span className={`${classes.caret} ${caretClassName ?? ""}`} aria-hidden="true" />}
    </span>
  )
}
